import React from "react";
import { motion } from "framer-motion";

interface BrandDesignHeroProps {
  background: string;
  logo: string;
  name: string;
}

const BrandDesignHero: React.FC<BrandDesignHeroProps> = ({ background, logo, name }) => {
  return (
    <section className="relative w-full bg-cover bg-center flex flex-col md:flex-row items-center md:items-start px-5 py-20" style={{ backgroundImage: `url(${background})` }}>
      <div className="absolute inset-0 bg-black opacity-60"></div>

      <div className="z-10">
        <motion.div
          initial={{ x: -250 }}
          animate={{ x: 0 }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          style={{ transformOrigin: "left" }}
        >
          <h2 className="text-white font-euro text-5xl">{name}</h2>
        </motion.div>

        <motion.div
          className="border-t-2 border-white my-5"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          style={{ transformOrigin: "left" }}
        ></motion.div>
        <h3 className="text-white font-euro text-3xl">Brand Design</h3>
      </div>

      <motion.img
        className="z-10 w-64 mt-5 md:mt-0 md:ml-16 lg:ml-24"
        src={logo}
        alt={`${name} Logo`}
        initial={{ y: -200, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      />
    </section>
  );
};

export default BrandDesignHero;
